import {
  GET_DATA_PG,
  EDIT_PG_MODE,
  DELETE_PG_MODE,
  ADD_PG_MODE,
  RESET_PG_SELECTED,
  CLEAR_PG,
  CREATE_PG,
  EDIT_PG,
  DELETE_PG,
  PG_SELECTED,
} from "redux/reducers/shipperTrucks/shipperTrucksReducer";
import { START_REQUEST_SEARCH, SET_SNACKBAR_SEARCH, STOP_REQUEST_SEARCH } from "redux/reducers/search/searchReducer";
import { PROYECT, api_get, api_post, api_put, api_delete } from "services/api";

export const getShipperTruck = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/shipper-trucks`;
  return async (dispatch) => {
    dispatch({ type: START_REQUEST_SEARCH });
    await api_get(url).then(resp => {
      dispatch({ type: GET_DATA_PG, payload: resp });
    }).catch(error => {
      const err = error.response?.data?.message?.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : "Error en el servidor", color: "danger" }
      });
    });
    dispatch({ type: STOP_REQUEST_SEARCH });
  };
};

export const addShipperTruck = (body) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/shipper-trucks`;
  return async (dispatch) => {
    dispatch({ type: START_REQUEST_SEARCH });
    await api_post(url, body).then(resp => {
      dispatch({ type: CREATE_PG, payload: resp });
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: "Shipper-truck creada con éxito", color: "success" }
      });
    }).catch(error => {
      const err = error.response?.data?.message?.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : "Error del servidor", color: "danger" }
      });
    });
    dispatch({ type: STOP_REQUEST_SEARCH });
  };
};

export const editShipperTruck = (id, body) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/shipper-trucks/${id}`;
  return async (dispatch) => {
    dispatch({ type: START_REQUEST_SEARCH });
    await api_put(url, body).then(resp => {
      dispatch({ type: EDIT_PG, payload: resp });
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: "Shipper-Truck editado con éxito", color: "success" }
      });
    }).catch(error => {
      const err = error.response?.data?.message?.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : "Error en el servidor", color: "danger" }
      });
    });
    dispatch({ type: STOP_REQUEST_SEARCH });
  };
};

export const deleteShipperTruck = (id) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/shipper-trucks/${id}`;
  return async (dispatch) => {
    dispatch({ type: START_REQUEST_SEARCH });
    await api_delete(url).then(() => {
      dispatch({ type: DELETE_PG, payload: id });
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: "Shipper-Truck eliminada exitosamente", color: "success" }
      });
    }).catch(error => {
      const err = error.response?.data?.message?.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : "Error en el servidor", color: "danger" }
      });
    });
    dispatch({ type: STOP_REQUEST_SEARCH });
  };
};

export const addShipperTruckMode = () => {
  return { type: ADD_PG_MODE };
};

export const editShipperTruckMode = () => {
  return { type: EDIT_PG_MODE };
};

export const deleteShipperTruckMode = () => {
  return { type: DELETE_PG_MODE };
};

export const resetShipperTruckSelected = () => {
  return { type: RESET_PG_SELECTED };
};

export const clearShipperTruck = () => {
  return { type: CLEAR_PG };
};

export const shipperTruckSelected = (id) => {
  return { type: PG_SELECTED, payload: id };
};
